import { render } from "./BaseButtonFab.vue?vue&type=template&id=66b50c6d&scoped=true"
import script from "./BaseButtonFab.vue?vue&type=script&lang=js"
export * from "./BaseButtonFab.vue?vue&type=script&lang=js"

import "./BaseButtonFab.vue?vue&type=style&index=0&id=66b50c6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b50c6d"]])

export default __exports__